import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from 'config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon
} from '../../components'
import Styles from './Data.css'

@CSSModules(Styles, {allowMultiple:true})
export default class Data extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'The data',
      description: 'We rate retirement plans and mutual funds on environmental and social sustainability issues.',
      url: config.domain + config.routes.data
    }
  }

  render() {
    const iconPlans = require( '../../../static/images/icon-plans.png' )
    const iconTargetDates = require( '../../../static/images/icon-target-dates.png' )
    const iconMutualFunds = require( '../../../static/images/icon-mutual-funds.png' )
    const iconManagers = require( '../../../static/images/icon-managers.png' )
    const iconCompanies = require( '../../../static/images/icon-companies.png' )
    const iconMethodology = require( '../../../static/images/icon-methodology.png' )

    const descriptions = {
      'Retirement plans': 'Most retirement plans are structured as a list of 10-20 investment options. Our sustainability scorecard rates employer-offered 401(k)s and other retirement plans based on their investments in fossil fuels, arms manufacturers, and other environmentally and socially risky companies.',
      'Asset managers': 'Retirement plans are usually based around funds from major asset managers like Vanguard, BlackRock, and Fidelity. We analyze these managers\' funds to measure their investments in sustainability risk sectors.',
      'Target date funds': 'Target date funds are a series of funds, where each fund in the series is marketed at investors with different retirement time horizons. The default option in employer-offered retirement plans is often a target date fund series. We\'ve rated 12 of the largest target date funds on environmentally and social risk issues.',
      'Mutual funds & ETFs': 'We rate mutual funds and ETFs on environmental and social sustainability risks based on what stocks the fund is invested in, including fossil fuels, deforestation, gender equality, civilian firearms, the prison industrial complex, arms manufacturers and military contractors, and tobacco.',
      'Publicly-traded companies': 'Using research from a wide range of issue experts, we track sustainability risks for thousands of global companies across environmental and social issues.',
      'Methodology': 'Detailed methodology on how we track investments, analyze sustainability risk, and assign portfolio ratings.'
    }
    //
    return (
      <div styleName='page'>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }
        <ContainerDivs>
          <h1 styleName='title'>
            {this.state.title}
          </h1>
          <div styleName='copy'>
            <nav>
              {
                [
                  [config.routes.plans, 'Retirement plans', iconPlans],
                  [config.routes.targetDateFunds, 'Target date funds', iconTargetDates],
                  [config.routes.mutualFundsETFs, 'Mutual funds & ETFs', iconMutualFunds],
                  [config.routes.assetManagers, 'Asset managers', iconManagers],
                  [config.routes.companies, 'Publicly-traded companies', iconCompanies],
                  [config.routes.methodology, 'Methodology', iconMethodology],
                ].map((e, i) => {
                  const [url, title, icon] = e
                  const description = descriptions[title] || 'Lorem'
                  return (
                    <div>
                      <button
                        styleName='data-link'
                        key={'data-link-'+i}
                      >
                        <Link
                          to={url}
                          title={title}
                        >
                          <div styleName='data-link-in'>
                            <img
                              src={icon}
                              alt={title}
                            />
                            <div>
                              <h2>
                                {title}
                              </h2>
                              <p>
                                {description}
                              </p>
                              <p>Learn more<LinkIcon/></p>
                            </div>
                          </div>
                        </Link>
                      </button>
                      <hr/>
                    </div>
                  )
                })
              }
            </nav>
          </div>
        </ContainerDivs>

        <br/>
        <br/>
        <br/>
      </div>
    )
  }
}